export default __webpack_public_path__ + "static/media/gatling.aa28deb4.svg";